import React, {useRef, useState} from 'react';
import * as Yup from "yup";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import {connect, useSelector} from "react-redux";
import { useForm } from "react-hook-form";


// components
import LabelLangs from "./_langs";
import { CustomMiniButtonX, GenericTableButton } from "../../../components/buttons/buttonsActions";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

// labels
import {
    FORM, INTERNATIONAL, REQUIRED
} from "../../../components/i18n/i18n";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// services & providers
import {labelService} from "../../../jwt/_services/configuration/labelService";

// actions
import {confirmAlert} from "react-confirm-alert";
import FirebaseTarget from "../../../components/firebaseTarget/firebaseTarget";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {setForm, setItem, setLoading, setViewMode} from "../../../redux/actions/generics/IndexedActions";

const LabelForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { app, editMode, domainObject } = componentState?.data || {};

    const [langs, setLangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []

    const [showHistoryModal, setShowHistoryModal] = useState(true);
    const modalHistoryRef = useRef(null);

    const showHistory = () => {
        setShowHistoryModal(true);
        modalHistoryRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: domainObject?.code,
            description: domainObject?.description,
        }
    });

    const submitSwitch = (data) => {
        if (app?.fbDataBase !== undefined) {
            onSubmit(data);
        } else {
            confirmSubmit(data);
        }
    }

    const onSubmit = (data, fbData, _) => {
        let dataRequest = {
            item : {
                ...data,
                langs: langs,
            }
        };

        if (app?.fbDataBase !== undefined) {
            dataRequest.fbDataBase = { id : app?.fbDataBase?.id }
        } else {
            dataRequest.noDb = fbData.noDb;
            dataRequest.allDb = fbData.allDb;
            dataRequest.existingDb = fbData.existingDb;

            fbData?.fbDataBase && fbData?.fbDataBase?.id && (dataRequest.fbDataBase = { id : fbData.fbDataBase.id });
        }

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, labelService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, labelService, dataRequest)
        }

        closeForm()
    };

    const confirmSubmit = (data) => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => {
            return <FirebaseTarget
                className={"langLabel"}
                data={data}
                onSubmit={onSubmit}
                onClose={onClose}
            />
        }
    });

    const closeForm = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path, false, false, false);
        props.onClose();
    }

    return (<>
            <Form onSubmit={handleSubmit(submitSwitch)}>
                <Card className={'card-modal-small'}>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="far fa-edit mr-2"/>{FORM}
                        <div className="float-right">
                            <GenericTableButton
                                toolTip={TT_SAVE}
                                icon={'fa-save'}
                                permission={'add'}
                                type={'submit'}
                            />
                            {
                                editMode && <GenericTableButton
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                            }
                            <CustomMiniButtonX
                                toolTip={TT_CLOSE}
                                icon={'fa-times'}
                                permission={'search'}
                                onClick={closeForm}
                            />
                        </div>
                    </CardTitle>
                    <CardBody>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label>Codigo</Label>
                                    <Input type="text" name="code"
                                           placeholder=" Código"
                                           innerRef={register}
                                           className={(errors.code ? ' is-invalid' : '')}
                                    />
                                    { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label>Descripción</Label>
                                    <Input type="textarea"
                                           rows="3"
                                           name="description"
                                           placeholder="Ingrese una descripción"
                                           innerRef={register}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <CardTitle className="bg-light border-bottom p-3 mb-0">
                            <i className="fas fa-language mr-2"/>{ INTERNATIONAL }
                        </CardTitle>
                        <CardBody>
                            <LabelLangs
                                langs={langs}
                                setLangs={setLangs}
                                translatableLangs={translatableLangs}
                            />
                        </CardBody>
                    </CardBody>
                </Card>
            </Form>

            {
                showHistoryModal && <LogHistoryModal
                    ref={ modalHistoryRef }
                    item={ domainObject }
                />
            }
        </>
    )
}

const mapStateToProps = _ => ({
})

const mapActionsToProps = ({
    setViewMode,
    setItem,
    setForm,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(LabelForm)